import EditIcon from 'Assets/Icons/edit-icon.svg';

export const NameInput = ({
  formik,
  mobile,
  label,
  value,
  placeholder,
  disabled,
  type,
  showLabel
}) => {
  return (
    <>
      <div className="input-group">
        {showLabel && <label>{placeholder}</label>}
        <input
          autoComplete="off"
          maxLength={25}
          placeholder={placeholder}
          type={type ? type : 'text'}
          disabled={disabled}
          value={value}
          {...formik?.getFieldProps(label)}
          onInput={(e) => {
            e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, ''); // Remove numbers
          }}
          onChange={(e) => {
            const value = e.target.value.replace(/\s/g, ''); // Remove spaces
            formik.setFieldValue(label, value);
          }}
          onBlur={formik.handleBlur}
          className={
            formik.touched[label] && formik.errors[label] ? 'error' : ''
          }
        />
        <p className="">
          {formik?.touched[label] &&
            formik?.errors[label] &&
            formik?.errors[label]}
        </p>
      </div>
    </>
  );
};

export const CustomInputBoxWithEditIcon = ({ value, onClick }) => {
  return (
    <>
      <div className="input-group">
        <div className="edit-icon-input-box">
          <div>{value}</div>
          <img
            onClick={onClick}
            src={EditIcon}
            alt="Edit Icon"
            className="edit-icon"
          />
        </div>
      </div>
    </>
  );
};
